import {CREATE_COREVALUE_SUCCESS, CREATE_COREVALUE_REQUEST, CREATE_COREVALUE_FAILURE} from './corevalueTypes'

const initialState = {
  loading: true,
  data: [],
  errorMsg: '',
};

const corevalueReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COREVALUE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_COREVALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: '',
      };
    case CREATE_COREVALUE_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default corevalueReducer